import { Injectable, EventEmitter } from '@angular/core';
import { ApiService } from '../../../core/services/api.service';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../../core/shared/classes/api';
import {Configuration} from "../classes/configuration";

@Injectable()
export class ConfigurationService {

    constructor (private apiService: ApiService) {}

    getScoringCriteres(): Observable<ApiResponse> {
        return this.apiService.get('scoring');
    }

    updateCritereScoring(id: string, data: any): Observable<ApiResponse> {
        return this.apiService.put('scoring/' + id, data);
    }

    getCritereRecherche(etat?: string, favoris?: string, withAcl?: string): Observable<ApiResponse> {
        return this.apiService.get('critere-recherche' + (etat ? '/etat/' + etat : '') + (favoris ? '/favoris/' + favoris : '') + (withAcl ? '/acl/' + withAcl : ''));
    }

    updateCritereRecherche(id: string, data: any): Observable<ApiResponse> {
        return this.apiService.put('critere-recherche/' + id, data);
    }

    updateOrderCriteresRecherche(data: any): Observable<ApiResponse> {
        return this.apiService.put('critere-recherche/order', data);
    }

    insertCritereRecherche(data: any): Observable<ApiResponse> {
        return this.apiService.post('critere-recherche', data);
    }

    deleteCritereRecherche(id: string): Observable<ApiResponse> {
        return this.apiService.delete('critere-recherche/' + id);
    }

    uploadLogo(file: File, logo_type: string, getEvent?: Function): Observable<ApiResponse> {
        const httpOptions = { reportProgress: true };
        const formData = new FormData();
        formData.append('fileKey', file);
        formData.append('name', file.name);
        return this.apiService.upload('upload/logo/' + logo_type, formData, getEvent);
    }

    deleteLogo(logo_type: string, getEvent?: Function): Observable<ApiResponse> {
        return this.apiService.delete('delete/logo/' + logo_type, getEvent);
    }

    getConfiguration(): Observable<ApiResponse> {
        return this.apiService.get('configuration');
    }

    updateConfiguration(data: any): Observable<ApiResponse> {
        return this.apiService.post('configuration', data);
    }

    migration(etape?: string): Observable<ApiResponse> {
        return this.apiService.get('migration' + (etape ? '/' + etape : ''));
    }

    getConfigurationClient(): Observable<ApiResponse> {
        return this.apiService.get('configuration-client', {}, {}, "configuration_client");
    }

    async getOptionModuleCalcul() {
        let configuration: Configuration = null;
        const configurationStr = localStorage.getItem('configuration');

        if (configurationStr) {
            configuration = JSON.parse(configurationStr);
        } else {
            const response = await this.getConfiguration().toPromise();
            if (response.status === 200) {
                configuration = new Configuration(response.data);
                localStorage.setItem('configuration', JSON.stringify(configuration));
            }
        }

        return configuration ? +configuration.module_calcul_prix_a17 === 1 : false;
    }

    getClasseComptable(): Observable<ApiResponse> {
        return this.apiService.get('configuration/classe-comptable');
    }

    updateClasseComptable(data: any): Observable<ApiResponse> {
        return this.apiService.post('configuration/classe-comptable/update', data);
    } 

}
